// /app/frontend/src/pages/compliance/vendor/constants-simplified.js
// Simplified Vendor Management Constants - Caribbean Focus
export { COUNTRIES as CARIBBEAN_COUNTRIES } from '../../../constants/compliance';

// Tab configuration
export const SIMPLIFIED_VENDOR_TABS = [
  { id: 'vendor-info', label: 'Vendor Info' },
  { id: 'due-diligence', label: 'Due Diligence' },
  { id: 'contract', label: 'Contract' },
  { id: 'risk-review', label: 'Risk & Review' },
];


// Contract types
export const CONTRACT_TYPES = [
  { value: 'none', label: 'None' },
  { value: 'dpa', label: 'Data Processing Agreement (DPA)' },
  { value: 'msa', label: 'Master Service Agreement (MSA)' },
  { value: 'service_agreement', label: 'Service Agreement' },
  { value: 'nda', label: 'Non-Disclosure Agreement (NDA)' },
  { value: 'other', label: 'Other' },
];

// Contract statuses
export const CONTRACT_STATUSES = [
  { value: 'no_contract', label: 'No Contract' },
  { value: 'draft', label: 'Draft' },
  { value: 'under_review', label: 'Under Review' },
  { value: 'signed', label: 'Signed' },
  { value: 'expired', label: 'Expired' },
];

// Risk tiers - MUST match backend VendorV2.risk_tier: Literal["not_assessed", "low", "medium", "high", "critical"]
export const RISK_TIERS = [
  { value: 'not_assessed', label: 'Not Assessed', color: 'bg-gray-500' },
  { value: 'low', label: 'Low', color: 'bg-green-500' },
  { value: 'medium', label: 'Medium', color: 'bg-yellow-500' },
  { value: 'high', label: 'High', color: 'bg-red-500' },
  { value: 'critical', label: 'Critical', color: 'bg-red-700' },
];

// Lifecycle stages
export const LIFECYCLE_STAGES = [
  { value: 'prospect', label: 'Prospect' },
  { value: 'active', label: 'Active' },
  { value: 'under_review', label: 'Under Review' },
  { value: 'terminated', label: 'Terminated' },
];

// Assessment outcomes
export const ASSESSMENT_OUTCOMES = [
  { value: 'not_assessed', label: 'Not Assessed' },
  { value: 'acceptable', label: 'Acceptable' },
  { value: 'requires_action', label: 'Requires Action' },
  { value: 'unacceptable', label: 'Unacceptable' },
];

// Common certifications
export const CERTIFICATIONS = [
  'ISO/IEC 27001',
  'SOC 2 Type II',
  'SOC 1 Type II',
  'PCI-DSS',
  'ISO 9001',
  'Cyber Essentials',
  'HIPAA',
  'GDPR Compliant',
];

// Approximate sizes
export const COMPANY_SIZES = [
  { value: '1-10', label: '1-10 employees' },
  { value: '11-50', label: '11-50 employees' },
  { value: '51-200', label: '51-200 employees' },
  { value: '201-500', label: '201-500 employees' },
  { value: '500+', label: '500+ employees' },
];

// Data categories processed
export const DATA_CATEGORIES = [
  'Personal Data',
  'Special Category Data',
  'Financial Information',
  'Health Data',
  'Biometric Data',
  'Genetic Data',
  'Location Data',
  'Device Data',
  'Usage Analytics',
  'Customer Profile Data',
  'Employee Data',
  'Vendor Data',
];

// Data subjects affected
export const DATA_SUBJECTS = [
  'Employees',
  'Customers',
  'Prospective Customers',
  'Business Partners',
  'Vendors/Suppliers',
  'Patients',
  'Residents',
  'Citizens',
  'Website Visitors',
  'Job Applicants',
  'Contractors',
  'Third Party Individuals',
];

// Risk Assessment Questions - Question-based simplified approach
export const RISK_ASSESSMENT_QUESTIONS = [
  {
    id: 'q1',
    question: 'What type of data does this vendor handle for you?',
    options: [
      { label: 'Basic business data only (names, emails, phone numbers)', score: 1, value: 'basic' },
      { label: 'Sensitive personal data (financial, health, employment records)', score: 2, value: 'sensitive' },
      { label: 'Special category data (biometric, genetic, racial/ethnic, political, sexual orientation)', score: 3, value: 'special' },
      { label: 'Children\'s data', score: 4, value: 'children' },
    ]
  },
  {
    id: 'q2',
    question: 'How many people\'s data does this vendor process?',
    options: [
      { label: 'Under 500', score: 1, value: 'under500' },
      { label: '500 to 5,000', score: 2, value: '500to5k' },
      { label: '5,000 to 50,000', score: 3, value: '5kto50k' },
      { label: 'Over 50,000', score: 4, value: 'over50k' },
    ]
  },
  {
    id: 'q3',
    question: 'Where does this vendor store or process the data?',
    options: [
      { label: 'Same country as our organisation', score: 1, value: 'samecountry' },
      { label: 'Within the Caribbean region', score: 1.5, value: 'caribbean' },
      { label: 'USA, UK, EU, or Canada', score: 2, value: 'useu' },
      { label: 'Other international locations or unknown', score: 3, value: 'other' },
    ]
  },
  {
    id: 'q4',
    question: 'Does this vendor have a signed data processing agreement or contract covering data protection?',
    options: [
      { label: 'Yes, comprehensive agreement in place', score: 1, value: 'yescomprehensive' },
      { label: 'Yes, but basic contract without specific data protection terms', score: 2, value: 'yesbasic' },
      { label: 'No formal agreement, or still being negotiated', score: 3, value: 'noformal' },
      { label: 'Don\'t know', score: 3, value: 'unknown' },
    ]
  },
  {
    id: 'q5',
    question: 'What security measures does this vendor have?',
    options: [
      { label: 'Certified (ISO 27001, SOC 2, or equivalent)', score: 1, value: 'certified' },
      { label: 'Has documented security policies but no certification', score: 2, value: 'documented' },
      { label: 'Claims to have security but no documentation provided', score: 3, value: 'claims' },
      { label: 'Unknown or no security measures discussed', score: 4, value: 'unknown' },
    ]
  },
  {
    id: 'q6',
    question: 'Has this vendor had any known data breaches or security incidents?',
    options: [
      { label: 'No known incidents', score: 1, value: 'none' },
      { label: 'Minor incident, fully resolved with improvements made', score: 2, value: 'minor' },
      { label: 'Significant incident in the past 2 years', score: 3, value: 'significant' },
      { label: 'Multiple incidents or ongoing concerns', score: 4, value: 'multiple' },
    ]
  },
  {
    id: 'q7',
    question: 'How critical is this vendor to your operations?',
    options: [
      { label: 'Nice to have, easily replaceable', score: 1, value: 'nicetohave' },
      { label: 'Important but alternatives exist', score: 2, value: 'important' },
      { label: 'Critical to operations, difficult to replace', score: 3, value: 'critical' },
      { label: 'Sole provider, no alternative available', score: 4, value: 'soleprovider' },
    ]
  }
];

// Risk Assessment Recommendations based on tier
export const RISK_TIER_RECOMMENDATIONS = {
  low: {
    tier: 'low',
    label: 'Low Risk',
    color: 'bg-green-500',
    recommendation: 'Standard annual review. No immediate action required.'
  },
  medium: {
    tier: 'medium',
    label: 'Medium Risk',
    color: 'bg-yellow-500',
    recommendation: 'Enhanced monitoring recommended. Review this vendor every 6 months. Consider requesting additional security documentation.'
  },
  high: {
    tier: 'high',
    label: 'High Risk',
    color: 'bg-red-500',
    recommendation: 'Mitigation plan required. Review quarterly. Ensure a comprehensive data processing agreement is in place. Escalate to DPO if applicable.'
  },
  critical: {
    tier: 'critical',
    label: 'Critical Risk',
    color: 'bg-red-700',
    recommendation: 'Immediate action required. Escalate to DPO. Consider suspending data sharing until critical gaps are resolved. Review monthly.'
  }
};

// Initial form data
export const SIMPLIFIED_VENDOR_INITIAL_DATA = {
  organization_id: '',
  vendor_name: '',
  trading_name: '',
  registration_number: '',
  country_of_registration: 'JM',
  when_formed: '',
  approximate_size: '',
  website_url: '',
  service_description: '',
  certifications: [],
  primary_contact: {
    name: '',
    email: '',
    phone: '',
  },
  due_diligence: {
    assessment_date: '',
    assessor_name: '',
    assessor_comments: '',
    personal_data_description: '',
    business_processes: '',
    data_storage_countries: [],
    data_guaranteed_in_country: null,
    special_category_data: null,
    special_category_description: '',
    encryption_in_transit: null,
    encryption_in_transit_standard: '',
    encryption_at_rest: null,
    encryption_at_rest_standard: '',
    dsr_procedures_in_place: null,
    data_return_on_termination: null,
    data_return_procedure: '',
    security_procedures: '',
    who_has_access: '',
    access_controls: '',
    breach_detection_procedures: '',
    audit_facilities: '',
    breach_reporting_procedures: null,
    breach_reporting_details: '',
    breaches_in_last_3_years: null,
    breach_history_details: '',
    independent_audits: null,
    last_audit_date: '',
    uses_sub_processors: null,
    sub_processors_list: '',
    sub_processors_authorized_by: '',
    sub_processors_written_agreements: null,
    assessment_outcome: 'not_assessed',
    actions_required: '',
    assessment_completion_date: '',
    final_comments: '',
  },
  contract_info: {
    contract_type: 'none',
    contract_type_other: '',
    contract_status: 'no_contract',
    effective_date: '',
    expiry_date: '',
    auto_renewal: false,
    renewal_notice_days: 30,
    dpa_signed: null,
    dpa_signed_date: '',
    contractual_terms_summary: '',
    applicable_law: '',
  },
  risk_assessment: {
    risk_tier: 'not_assessed',
    risk_notes: '',
    last_reviewed_date: '',
    next_review_due_date: '',
    reviewed_by: '',
  },
  notes: '',
  lifecycle_stage: 'prospect',
};
